import { useState } from "react";
import { fileUrl } from "@/lib/api";
import { STATUS, fmtCoin, coinToRp } from "@/lib/format";
import { BadgeCheck, Crown, Inbox, User } from "lucide-react";

export function UAvatar({ path, name, className = "w-12 h-12" }) {
  const [err, setErr] = useState(false);
  if (path && !err) {
    return <img src={fileUrl(path)} onError={() => setErr(true)} alt={name} className={`${className} rounded-full object-cover bg-slate-200`} />;
  }
  return (
    <div className={`${className} rounded-full bg-gradient-to-br from-emerald-100 to-teal-200 text-emerald-800 grid place-items-center font-display font-bold`}>
      {name ? name.slice(0, 1).toUpperCase() : <User className="w-1/2 h-1/2" />}
    </div>
  );
}

export function Verified({ show, className = "w-4 h-4" }) {
  if (!show) return null;
  return <BadgeCheck data-testid="verified-blue-badge" className={`${className} text-white fill-blue-500 shrink-0`} />;
}

export function FeaturedBadge({ show, compact = false }) {
  if (!show) return null;
  return (
    <span data-testid="featured-worker-badge" title="Worker Unggulan: profil lengkap, terverifikasi & 4 sertifikat"
      className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-amber-400 to-amber-500 text-white font-bold shrink-0 ${compact ? "px-1.5 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs"}`}>
      <Crown className={compact ? "w-3 h-3" : "w-3.5 h-3.5"} />{compact ? "Unggulan" : "Worker Unggulan"}
    </span>
  );
}

export function StatusBadge({ status }) {
  const s = STATUS[status] || { label: status, cls: "bg-slate-100 text-slate-700" };
  return <span data-testid={`status-badge-${status}`} className={`inline-flex px-2.5 py-1 rounded-full text-[11px] font-semibold ${s.cls}`}>{s.label}</span>;
}

export function Coin({ value, showRp = true, className = "" }) {
  return (
    <span className={`inline-flex items-baseline gap-1 ${className}`}>
      <span className="font-mono font-bold">{fmtCoin(value)} koin</span>
      {showRp && <span className="text-xs text-slate-500">({coinToRp(value)})</span>}
    </span>
  );
}

export function Empty({ title, desc, testid = "empty-state" }) {
  return (
    <div data-testid={testid} className="text-center py-10 px-6 rounded-2xl border border-dashed border-slate-300 bg-white/60">
      <Inbox className="w-8 h-8 mx-auto text-slate-400" />
      <p className="mt-2 font-semibold text-slate-700">{title}</p>
      {desc && <p className="text-sm text-slate-500 mt-1">{desc}</p>}
    </div>
  );
}

export function PageHead({ title, sub, right }) {
  return (
    <div className="flex items-end justify-between gap-3 mb-5">
      <div>
        <h1 className="font-display text-2xl font-extrabold tracking-tight text-slate-900">{title}</h1>
        {sub && <p className="text-sm text-slate-500 mt-0.5">{sub}</p>}
      </div>
      {right}
    </div>
  );
}

export function Img({ path, className, alt = "" }) {
  if (!path) return <div className={`${className} bg-slate-200`} />;
  return <img src={fileUrl(path)} alt={alt} className={`${className} object-cover`} />;
}
